'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import CodeSplitEnvWrapper from 'pricing-pages-unified-ui/components/CodeSplitEnvWrapper';
import { MERCH_CARD } from 'pricing-pages-unified-ui/constants/Tracking';
import { productLineToHub } from 'self-service-api/constants/ProductLineToHub';
import LoadingMerchCardAuthedCTAs from 'pricing-pages-unified-ui/components/loading/LoadingMerchCardAuthedCTAs';
import { useMerchCardAuthedCTAsProps } from 'pricing-pages-unified-ui/components/product-pages/useMerchCardAuthedCTAsProps';
import { useMerchCardPublicCTAsProps } from './useMerchCardPublicCTAsProps';
import LoadingMerchCardPublicCTAs from '../loading/LoadingMerchCardPublicCTAs';
import { upgradeProductSelector } from '../../selectors/ProductsSelectors';

const MerchCardCTAsContainer = props => {
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [props.skuId]
  }));
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import(
    /* webpackChunkName: "authed-chunk" */
    `pricing-pages-unified-ui/components/auth-cta-motions/AuthedCTAs`),
    publicComponentLoader: () => import(
    /* webpackChunkName: "public-chunk" */
    `pricing-pages-unified-ui/components/public-only/MerchCardPublicCTAs`),
    authedComponentProps: Object.assign({}, props, {
      trackingSource: props.trackingSource || MERCH_CARD
    }),
    publicComponentProps: Object.assign({}, props, {
      sourceId: props.trackingSource || 'pricing-hero',
      dtbSource: `pricing-page|${productLineToHub[props.productLine]}-hub|${props.trackingSource || MERCH_CARD}|${upgradeProduct}`
    }),
    publicComponentLoadingState: LoadingMerchCardPublicCTAs,
    authedComponentLoadingState: LoadingMerchCardAuthedCTAs,
    useCommonAuthedProps: useMerchCardAuthedCTAsProps,
    useCommonPublicProps: useMerchCardPublicCTAsProps,
    preload: true
  });
};

export default MerchCardCTAsContainer;